import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography } from "@bookips/sds";
import { RadiusBoxStyle } from ".";
export const NotFoundItemError = (param)=>{
    let { handleRouting  } = param;
    return /*#__PURE__*/ _jsx(RadiusBoxStyle, {
        children: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col items-center gap-4 text-center",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    variant: "h6",
                    className: "text-strong",
                    children: "결제 정보를 불러오지 못했어요."
                }),
                /*#__PURE__*/ _jsx(Button, {
                    variant: "fill",
                    onClick: handleRouting,
                    className: "bg-primary-main px-4 py-2 ",
                    children: "메인으로 돌아가기"
                })
            ]
        })
    });
};
